import React from 'react';
import { useLocation } from 'react-router-dom';

import { useAppConfig } from "../context/AppConfigContext";
import MainList from '../components/main/MainList';

const LandingPage = () => {
  const { appConfigDict } = useAppConfig();
  console.log("appConfigDict is...", appConfigDict);

  const location = useLocation();
  const path = location.pathname.startsWith("/") ? location.pathname.slice(1) : location.pathname; // Remove leading "/"

  const displayRecall = {'compositeId': path};
  if (!!path) {
    console.log("Recall to display is...", displayRecall);
  }

  return (
    <>
        <MainList displayRecall={displayRecall}/>
    </>
  );
};

export default LandingPage;
